var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBellFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4956 6.75V10.75C2.49565 11.1247 2.41154 11.4947 2.24948 11.8326C2.08742 12.1704 1.85154 12.4675 1.55928 12.702L1.25016 12.9501C-0.220352 14.1303 0.616629 16.5 2.4996 16.5H16.0036C17.8866 16.5 18.7236 14.1304 17.2531 12.9501L16.9444 12.7024C16.3524 12.2264 16.0076 11.5081 16.0076 10.75V6.75C16.0072 5.86318 15.832 4.98476 15.4923 4.16562C15.1525 3.34648 14.6547 2.60228 14.0273 1.97552C13.3999 1.34876 12.6552 0.851711 11.8357 0.512751C11.0164 0.173838 10.1379 -0.000392704 9.25123 6.64606e-07C5.52092 0.000203641 2.4956 3.02118 2.4956 6.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75159 18C7.33737 18 7.00159 18.3358 7.00159 18.75C7.00159 19.1642 7.33737 19.5 7.75159 19.5H10.7516C11.1658 19.5 11.5016 19.1642 11.5016 18.75C11.5016 18.3358 11.1658 18 10.7516 18H7.75159Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFilled);
export default __webpack_public_path__ + "static/media/bell-filled.2b8e691567218607fc7c67e326c6a9ce.svg";
export { ForwardRef as ReactComponent };